import { TContentAutomationStep } from './types';

export const CONTENT_AUTOMATION_STEP_DURATION_MS = 3_200;

export const CONTENT_AUTOMATION_STEPS: readonly TContentAutomationStep[] = [
  {
    key: 'references',
    title: 'Detect references',
    messages: ['Identifying references in content', 'Inserting references'],
  },
  {
    key: 'data',
    title: 'Detect data',
    messages: ['Identifying redundant regulatory information', 'Consolidating regulatory data'],
  },
  {
    key: 'structure',
    title: 'Detect document structure',
    messages: ['Identifying matching template', 'Applying template structure'],
  },
];
